/** Tiny cross-view UI state the feedback context reads (monolith fbContext
 *  reads the wizard's `page` global). FormView writes `step` on every
 *  navigation; App reads it when composing the feedback payload. */
export const ui = { step: 1 };
